/* src/app/redirect/redirect.component.scss */
/*# sourceMappingURL=redirect.component.css.map */
